<div>
  <div class="full-dialog-background"></div>
  <img src="assets/images/dialogs/dialog-please-wait.svg" class="please-wait-dialog" />
</div>
